import { render, staticRenderFns } from "./LoadSys.vue?vue&type=template&id=80c84cf6&scoped=true"
import script from "./LoadSys.vue?vue&type=script&lang=js"
export * from "./LoadSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c84cf6",
  null
  
)

export default component.exports